import { render } from "./IconAdv1.vue?vue&type=template&id=02244415&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconAdv1.vue?vue&type=script&lang=js"
export * from "./IconAdv1.vue?vue&type=script&lang=js"
script.render = render

export default script